import { useState } from "react";
import axios from "axios";
import { Lock, RefreshCw, Calendar, Phone, Mail, MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS = ["pendente", "confirmado", "concluido", "cancelado", "expirado", "novo"];
const badge = {
  pendente: "bg-amber-100 text-amber-700",
  confirmado: "bg-royal/10 text-royal",
  concluido: "bg-green-100 text-green-700",
  cancelado: "bg-red-100 text-red-700",
  expirado: "bg-slate-200 text-slate-600",
  novo: "bg-royal/10 text-royal",
};

export default function Admin() {
  const [key, setKey] = useState("");
  const [authed, setAuthed] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [error, setError] = useState("");

  const load = async (k) => {
    try {
      const res = await axios.get(`${API}/bookings`, { headers: { "x-admin-key": k } });
      setBookings(res.data);
      setAuthed(true);
      setError("");
    } catch {
      setError("Chave inválida.");
    }
  };

  const updateStatus = async (id, status) => {
    await axios.patch(`${API}/bookings/${id}?status=${status}`, {}, { headers: { "x-admin-key": key } });
    load(key);
  };

  if (!authed) {
    return (
      <div className="min-h-screen grid place-items-center bg-secondary px-5">
        <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-[0_20px_60px_rgba(0,47,171,0.1)]" data-testid="admin-login">
          <span className="grid place-items-center h-12 w-12 rounded-full bg-royal/10 text-royal mb-5"><Lock size={22} /></span>
          <h1 className="font-display font-bold text-2xl text-ink mb-2">Gestão de marcações</h1>
          <p className="text-muted-foreground text-sm mb-6">Introduza a chave de acesso.</p>
          <input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder="Chave" className="w-full rounded-xl border border-ink/15 px-4 h-12 mb-3 outline-none focus:border-royal" data-testid="admin-key-input" />
          {error && <p className="text-destructive text-sm mb-3">{error}</p>}
          <button onClick={() => load(key)} className="w-full rounded-full bg-royal text-white font-semibold h-12" data-testid="admin-login-btn">Entrar</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-secondary py-10 px-5">
      <div className="mx-auto max-w-5xl">
        <div className="flex items-center justify-between mb-8">
          <h1 className="font-display font-extrabold text-3xl text-ink">Marcações <span className="text-royal">({bookings.length})</span></h1>
          <button onClick={() => load(key)} className="inline-flex items-center gap-2 rounded-full border border-ink/15 bg-white px-5 h-11 font-medium"><RefreshCw size={16} /> Atualizar</button>
        </div>
        <div className="space-y-4">
          {bookings.length === 0 && <p className="text-muted-foreground">Ainda não há marcações.</p>}
          {bookings.map((b) => (
            <div key={b.id} className="rounded-2xl bg-white p-6 shadow-sm" data-testid={`admin-booking-${b.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <p className="font-display font-bold text-lg text-ink">{b.name} <span className={`ml-2 text-xs px-3 py-1 rounded-full ${badge[b.status] || "bg-muted"}`}>{b.status}</span></p>
                  <p className="text-royal font-medium">{b.service}</p>
                  <div className="mt-3 grid sm:grid-cols-2 gap-x-8 gap-y-1 text-sm text-muted-foreground">
                    <span className="flex items-center gap-2"><Calendar size={14} /> {b.date} às {b.time}</span>
                    <span className="flex items-center gap-2"><Phone size={14} /> {b.phone}</span>
                    <span className="flex items-center gap-2"><Mail size={14} /> {b.email}</span>
                    <span className="flex items-center gap-2"><MapPin size={14} /> {b.property_type}</span>
                  </div>
                  {b.address && <p className="mt-2 text-sm text-muted-foreground">Morada: {b.address}</p>}
                  {b.message && <p className="mt-1 text-sm text-ink/70 italic">"{b.message}"</p>}
                </div>
                <select value={b.status} onChange={(e) => updateStatus(b.id, e.target.value)} className="rounded-xl border border-ink/15 px-3 h-10 text-sm" data-testid={`admin-status-${b.id}`}>
                  {STATUS.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
